module.exports = __webpack_public_path__ + "img/20200610_155646.63fc91ba.jpg";